/*
* Utility script for a Sort form on an OnCloud TRE Property List.
*/
OC_TRE_sort = 
{
	init: function()
	{
		// Setup our UI.
		OC_TRE_sort.init_ui();
	}
	,
	init_ui: function()
	{
		jQuery('#tre-property-list select[name="sort_combo"]').change(function(){
			var combo = jQuery(this).val();
			var split = combo.split(',');
			var sort = split[0];
			var order = split[1];
			console.log(combo,sort,order);
			OC_TRE_sort.set_sorting(sort,order);
		});
	}
	,
	set_sorting: function(pm_sort = 'date', pm_order = 'asc')
	{
		// Set hidden fields to track sorting for the form.
		jQuery('#tre-property-list input[name="sort"]').val(pm_sort);
		jQuery('#tre-property-list input[name="order"]').val(pm_order);
	}
}

jQuery(document).ready(function(jQuery){
		
	console.log('Start TRE Sort script');
	OC_TRE_sort.init();
		
});